import { EditProfileDataFieldsProps } from './type';

export const EditProfileDataFields = ({ children, classNames, ...props }: EditProfileDataFieldsProps) => {
    const { onSubmit } = props;
    return (
        <form className={`${classNames}`} onSubmit={onSubmit} {...props}>
            {children}
        </form>
    );
};
